import { render, staticRenderFns } from "./YAxisSelector.vue?vue&type=template&id=2d7b3be2&scoped=true"
import script from "./YAxisSelector.vue?vue&type=script&lang=js"
export * from "./YAxisSelector.vue?vue&type=script&lang=js"
import style0 from "./YAxisSelector.vue?vue&type=style&index=0&id=2d7b3be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b3be2",
  null
  
)

export default component.exports